import { type FeatureModule } from '@/components/routing';

/** Routes and nav entries of the `dashboard` feature. */
export const dashboardFeature: FeatureModule = {
  id: 'dashboard',
  routes: [
    {
      index: true,
      lazy: async () => ({ Component: (await import('./pages/dashboard-page')).DashboardPage }),
    },
  ],
  navItems: [{ to: '/', ns: 'dashboard', labelKey: 'nav.dashboard', icon: 'chart', order: 10, end: true }],
};
